import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.features.listExportTasks.ExportTaskListPresenter`

// Sort option labels for the server sort keys (BHV-035).
export default defineMessages({
  sortDatePreparedLabel: {
    id: `${scope}.sortDatePreparedLabel`,
    defaultMessage: 'Date prepared',
  },
  sortRequestedByLabel: {
    id: `${scope}.sortRequestedByLabel`,
    defaultMessage: 'Requested by',
  },
})
